<template>
  <div class="modal-alert">
    <div class="alert">
      <span>
        <div class="cookies" >
          <div>
            <img :src="require('@/assets/cookie-27595_640.png')">
            <p>{{ alertText }}</p>
            <button @click="$emit('fechar-modal-Alert')" class="alertButton">Aceitar</button>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  data () {
    return {
      titulo: 'Aceitar Cookies:',
      alertText: 'Utilizamos ferramentas e serviços de terceiros que utilizam cookies. Essas ferramentas nos ajudam a oferecer uma melhor experiência de navegação no site. Ao clicar no botão “Aceitar”, você concorda com o uso de cookies em nosso site.'
    }
  }

}
</script>

<style lang="scss" >
 .modal-alert{
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    overflow-y: initial !important;
 }
  .modal-alert:target {
    opacity: 1;
    pointer-events: auto;
  }
  .alert {
    width: auto;
    position: fixed;
    padding: 10px;
    right: 1vw;
    bottom: 20px;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.753);
    border-radius: 5px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.25);
    color: white;
    display: flex;
    flex-wrap: wrap;

    div {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      div{
        display: flex;
        align-items: start;

      }

      h2{
        font-size: 1.5em;
        margin-top: 10px;
        color: #FFEC00;
      }
      p{
        display: flex;
        font-size: 1em;
        width: 80%;
      }

      .alertButton {
        color: white;
        width: auto;
        height: 1.8rem;
        border-radius: 5%;
      }
      img{
        display: flex;
        width: 2rem;
        align-self: center;
        margin-left: 2rem;
      }
    }
  }
</style>
